"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var localized_strings_1 = require("localized-strings");
exports.volumeUnits = new localized_strings_1.default({
    en: {
        AcreInch: {
            AbbreviatedDisplay: 'ac in',
            FullDisplay: 'acre inches'
        },
        Centiliter: {
            AbbreviatedDisplay: 'cL',
            FullDisplay: 'centiliters'
        },
        CubicFoot: {
            AbbreviatedDisplay: 'cu ft',
            FullDisplay: 'cubic feet'
        },
        CubicInch: {
            AbbreviatedDisplay: 'cu in',
            FullDisplay: 'cubic inches'
        },
        CubicMeter: {
            AbbreviatedDisplay: 'cu m',
            FullDisplay: 'cubic meters'
        },
        CubicYard: {
            AbbreviatedDisplay: 'cu yd',
            FullDisplay: 'cubic yards'
        },
        FluidOunce: {
            AbbreviatedDisplay: 'fl oz',
            FullDisplay: 'fluid ounces'
        },
        Gallon: {
            AbbreviatedDisplay: 'gal',
            FullDisplay: 'gallons'
        },
        Liter: {
            AbbreviatedDisplay: 'L',
            FullDisplay: 'liters'
        },
        Milliliter: {
            AbbreviatedDisplay: 'mL',
            FullDisplay: 'milliliters'
        },
        Pint: {
            AbbreviatedDisplay: 'pt',
            FullDisplay: 'pints'
        },
        Quart: {
            AbbreviatedDisplay: 'qt',
            FullDisplay: 'quarts'
        }
    },
    es: {
        Centiliter: {
            AbbreviatedDisplay: 'cL',
            FullDisplay: 'centilitros'
        },
        FluidOunce: {
            AbbreviatedDisplay: 'oz fl',
            FullDisplay: 'onzas fluidas'
        },
        Gallon: {
            AbbreviatedDisplay: 'gal',
            FullDisplay: 'galones'
        },
        Liter: {
            AbbreviatedDisplay: 'L',
            FullDisplay: 'litros'
        },
        Milliliter: {
            AbbreviatedDisplay: 'mL',
            FullDisplay: 'mililitros'
        },
        Pint: {
            AbbreviatedDisplay: 'pt',
            FullDisplay: 'pinta'
        },
        Quart: {
            AbbreviatedDisplay: 'qt',
            FullDisplay: 'quartos'
        }
    }
}, {
    logsEnabled: false
});
